import {Component, OnDestroy, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {FileService} from '../file/file.service';
import {Drawing} from './drawing.model';
import {DrawingService} from './drawing.service';
import {RoutePrefix} from '../shared/route-prefix';

@Component({
  selector: 'app-drawing-datatable',
  templateUrl: './drawing-datatable.component.html'
})
export class DrawingDatatableComponent extends DatatableViewComponent<Drawing> implements OnDestroy, OnInit {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  @Output() onDrawingsLoaded = new EventEmitter<any>();
  @Input() public routePrefix: RoutePrefix | RoutePrefix[];

  public entityType: string;

  constructor(
    protected router: UIRouter,
    protected drawingService: DrawingService,
    protected fileService: FileService
  ) {
    super(drawingService);
  }

  public ngOnDestroy(): void {
    this.drawingService.clearRoutePrefix();
  }

  ngOnInit(): void {
    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.drawingService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.fetchData();
  }

  public fetchData(): void {
    this.loading  = true;
    this.drawingService.getAll(this.requestParams).map((drawings: Drawing[]) => {
      return drawings.map((drawing) => {
        drawing.setFileSrc(this.fileService.getLinkById(drawing.fileId));
        return drawing;
      });
    }).subscribe((drawings: Drawing[]) => {
      this.rows = drawings;
      this.loading = false;
      this.onDrawingsLoaded.emit({type: this.entityType, items: this.rows});
    });
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.drawingService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

}




// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/drawing/drawing-datatable.component.ts